const FORM_PLACE_HOLDERS = {
  feinTaxId: 'Input Tax-Id of your loan-out entity',
  corpNumber: 'Input Corporation Number of your loan-out entity',
  entityName: "Input the loan-out entity's name",
  entityAddress: "Input the loan-out entity's current address",
  entityType: 'Select an entity type',
};

export { FORM_PLACE_HOLDERS };
